<template>
  <Bar
    :id="id"
    :data="data"
    :options="options"
    :plugins="plugins"
  />
</template>

<script setup>
import { Bar } from 'vue-chartjs';
import {
  Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale,
} from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
);

defineProps({
  id: {
    type: String,
    required: true,
  },
  data: {
    type: Object,
    required: true,
  },
  options: {
    type: Object,
    required: true,
  },
  plugins: {
    type: Array,
    default: () => [],
  },
});
</script>
